import type { Comp, GameObj, PosComp, ScaleComp } from "kaplay";
import { k } from "../core/kaplay";
import { viewport } from "../core/viewport";

export function screenCenter(): Comp {
    return {
        id: "screenCenter",
        require: ["pos", "scale"],
        update(this: GameObj<PosComp | ScaleComp>) {
            this.pos = k.center();
            this.scale = k.vec2(viewport.uiScale);
        },
    };
}
